'use client';
import React, { useEffect, useRef } from 'react';
import type { ComponentEmbeddedScript } from './types';

export const EmbeddedScript: React.FC<ComponentEmbeddedScript> = ({ html }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || !html) return;

    el.innerHTML = html;

    el.querySelectorAll('script').forEach((oldScript) => {
      const s = document.createElement('script');
      for (const attr of oldScript.attributes) {
        s.setAttribute(attr.name, attr.value);
      }
      s.text = oldScript.textContent ?? '';
      oldScript.replaceWith(s);
    });
  }, [html]);

  return <div ref={ref} />;
};
